import React, {useRef, useEffect} from 'react';

interface AppActionsMenuItem {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  className?: string;
}

interface AppActionsMenuProps {
  items: AppActionsMenuItem[];
  onClose: () => void;
  className?: string;
  style?: React.CSSProperties;
}

const AppActionsMenu: React.FC<AppActionsMenuProps> = ({items, onClose, className = '', style}) => {
  const menuRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    function handleClickOutside (event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  return (
    <div
      ref={menuRef}
      className={`w-[280px] bg-white border border-gray-200 rounded-lg p-4 shadow-lg space-y-4 animate-fade-in-up ${className}`}
      style={{animation: 'fade-in-up 0.25s cubic-bezier(.4,0,.2,1)', ...style}}
    >
      {items.map((item, idx) => (
        <button
          key={idx}
          className={`flex items-center justify-between w-full hover:bg-brand-50 hover:text-brand-700 rounded-md px-3 py-2 transition focus:outline-none border border-gray-200 focus:border-gray-500 ${item.className || ''}`}
          onClick={item.onClick}
          type="button"
        >
          <span className="text-grayText text-[15px] font-zain flex-1 text-right" style={{letterSpacing: '-0.4px'}}>
            {item.label}
          </span>
          <span className="w-6 h-6 flex items-center justify-center">
            {item.icon}
          </span>
        </button>
      ))}
      <style>{`
        @keyframes fade-in-up {
          0% { opacity: 0; transform: translateY(16px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default AppActionsMenu;
